var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcBook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.25098 7C7.25098 6.58579 7.58677 6.25 8.00098 6.25H16.001C16.4152 6.25 16.751 6.58579 16.751 7C16.751 7.41421 16.4152 7.75 16.001 7.75H8.00098C7.58677 7.75 7.25098 7.41421 7.25098 7ZM7.25 11C7.25 10.5858 7.58579 10.25 8 10.25H12C12.4142 10.25 12.75 10.5858 12.75 11C12.75 11.4142 12.4142 11.75 12 11.75H8C7.58579 11.75 7.25 11.4142 7.25 11Z",
    fill: "#76B72A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.25 4C3.25 2.48122 4.48122 1.25 6 1.25H20C20.4142 1.25 20.75 1.58579 20.75 2V18C20.75 18.4142 20.4142 18.75 20 18.75H6C5.30964 18.75 4.75 19.3096 4.75 20C4.75 20.6904 5.30964 21.25 6 21.25H20C20.4142 21.25 20.75 21.5858 20.75 22C20.75 22.4142 20.4142 22.75 20 22.75H6C4.48122 22.75 3.25 21.5188 3.25 20V4ZM4.75 17.5499C5.12503 17.3581 5.54989 17.25 6 17.25H19.25V2.75H6C5.30964 2.75 4.75 3.30964 4.75 4V17.5499Z",
    fill: "#76B72A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1237 17.5836C20.3537 17.928 20.261 18.3938 19.9165 18.6238C19.5446 18.8721 19.25 19.3742 19.25 20.0001C19.25 20.626 19.5446 21.128 19.9165 21.3764C20.261 21.6064 20.3537 22.0721 20.1237 22.4166C19.8937 22.7611 19.428 22.8538 19.0835 22.6238C18.2598 22.0737 17.75 21.0834 17.75 20.0001C17.75 18.9168 18.2598 17.9264 19.0835 17.3764C19.428 17.1463 19.8937 17.2391 20.1237 17.5836Z",
    fill: "#76B72A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBook);
export default __webpack_public_path__ + "static/media/ic-book.7d00de71d50fecb9b43195b5ace4c616.svg";
export { ForwardRef as ReactComponent };